<template>
  <div class="feedback_page">
    <div class="feedback_top">
      <div class="feedback_side">
        <div class="feedback_brand">Aicredit</div>
        <div class="feedback_side-content">
          <img class="feedback_icon" src="/static/img/fk.png" alt="" />
          <div class="feedback_side-title">Обратная связь</div>
          <div class="feedback_side-text">
            Доверие и уважение — наши главные принципы. Пожалуйста, расскажите нам о своей ситуации, и мы вместе найдем решение.
          </div>
        </div>
      </div>

      <div class="feedback_main">
        <div class="feedback_header">
          <div class="feedback_nav">
            <div class="feedback_nav-item" @click="goPage('/')">Главная</div>
            <div class="feedback_nav-item" @click="goPage('/obtain')">Как получить</div>
            <div class="feedback_nav-item" @click="goPage('/tutorial')">Как погасить</div>
            <div class="feedback_nav-item" @click="goPage('/conte')">Документы</div>
            <div class="feedback_nav-item" @click="goPage('/quiz')">Вопросы и ответы</div>
            <div class="feedback_nav-item feedback_nav-active">Обратная связь</div>
          </div>
        </div>

        <div class="feedback_body">
          <div class="feedback_title">Подать заявку</div>
          <div class="feedback_desc">Здесь вы можете отправить сообщение в службу поддержки клиентов.</div>

          <div class="feedback_form-card">
            <div class="feedback_field feedback_field-full">
              <div class="feedback_label">Фамилия<span>*</span></div>
              <input v-model="form.name" class="feedback_input" type="text" />
            </div>

            <div class="feedback_row">
              <div class="feedback_field">
                <div class="feedback_label">Номер телефона<span>*</span></div>
                <input v-model="form.phone" class="feedback_input" type="text" />
              </div>
              <div class="feedback_field">
                <div class="feedback_label">Ваш e-mail<span>*</span></div>
                <input v-model="form.email" class="feedback_input" type="text" />
              </div>
            </div>

            <div class="feedback_field feedback_field-full feedback_field-message">
              <div class="feedback_label">Сообщение (причина обращения)<span>*</span></div>
              <textarea v-model="form.message" class="feedback_textarea"></textarea>
            </div>

            <div class="feedback_action">
              <button class="feedback_button" type="button">Отправить заявку</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <BomTab :jumpindex="1"></BomTab>
  </div>
</template>

<script>
  import BomTab from '@/components/BomTab.vue'

  export default {
    name: 'feedback',
    components: {
      BomTab
    },
    data() {
      return {
        form: {
          name: '',
          phone: '',
          email: '',
          message: ''
        }
      }
    },
    methods: {
      goPage(path) {
        if (this.$route.path === path) {
          return
        }
        this.$router.push(path)
      }
    }
  }
</script>

<style scoped>
  .feedback_page {
    min-height: 100vh;
    background: #f7f8fd;
  }

  .feedback_top {
    min-height: 5rem;
    display: flex;
  }

  .feedback_side {
    width: 3.31rem;
    padding: 1.06rem 0.57rem 0;
    box-sizing: border-box;
    color: #ffffff;
    background: linear-gradient(180deg, #fb4117 0%, #f85a31 100%);
    position: relative;
    overflow: hidden;
  }

  .feedback_side::before,
  .feedback_side::after {
    content: '';
    position: absolute;
    border-radius: 50%;
    pointer-events: none;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 68%);
  }

  .feedback_side::before {
    width: 1.5rem;
    height: 1.5rem;
    right: -0.12rem;
    top: -0.08rem;
  }

  .feedback_side::after {
    width: 1.62rem;
    height: 1.62rem;
    left: -0.24rem;
    bottom: -0.05rem;
  }

  .feedback_brand,
  .feedback_side-content {
    position: relative;
    z-index: 1;
  }

  .feedback_brand {
    font-family: Inter, Inter;
    font-weight: 800;
    font-size: 0.14rem;
    line-height: 0.2rem;
  }

  .feedback_side-content {
    margin-top: 0.8rem;
  }

  .feedback_icon {
    width: 0.36rem;
    height: 0.36rem;
    margin-bottom: 0.17rem;
  }

  .feedback_side-title {
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 0.25rem;
    color: #FFFFFF;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-bottom: 0.13rem;
  }

  .feedback_side-text {
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 0.09rem;
    color: #FFB4A3;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .feedback_main {
    flex: 1;
    min-width: 0;
  }

  .feedback_header {
    height: 0.53rem;
    background: #ffffff;
    padding: 0 0.28rem;
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }

  .feedback_nav {
    display: flex;
    align-items: center;
    gap: 0.18rem;
    flex-wrap: wrap;
  }

  .feedback_nav-item {
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    text-align: left;
    font-style: normal;
    text-transform: none;
    cursor: pointer;
  }

  .feedback_nav-active {
    color: #F04B23;
    font-weight: 500;
    border-bottom: 0.02rem solid #FF5836;
    padding-bottom: 0.03rem;
  }

  .feedback_body {
    padding: 0.42rem 0.38rem 0;
    box-sizing: border-box;
  }

  .feedback_title {
    font-family: Inter, Inter;
    font-weight: 900;
    font-size: 0.19rem;
    line-height: 0.27rem;
    color: #2e3748;
    margin-bottom: 0.06rem;
  }

  .feedback_desc {
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 0.06rem;
    line-height: 0.11rem;
    color: #8a91a0;
    margin-bottom: 0.2rem;
  }

  .feedback_form-card {
    width: 3.34rem;
    max-width: 100%;
    background: #ffffff;
    border: 0.01rem solid #ebecef;
    border-radius: 0.08rem;
    box-shadow: 0 0.01rem 0.03rem rgba(0, 0, 0, 0.02);
    padding: 0.14rem 0.13rem 0.14rem;
    box-sizing: border-box;
  }

  .feedback_row {
    display: flex;
    gap: 0.13rem;
  }

  .feedback_field {
    flex: 1;
    margin-bottom: 0.13rem;
  }

  .feedback_field-full {
    width: 100%;
  }

  .feedback_field-message {
    margin-bottom: 0.16rem;
  }

  .feedback_label {
    margin-bottom: 0.06rem;
    font-family: Inter, Inter;
    font-weight: 700;
    font-size: 0.06rem;
    line-height: 0.1rem;
    color: #7b7e87;
  }

  .feedback_label span {
    color: #ff5836;
    margin-left: 0.01rem;
  }

  .feedback_input,
  .feedback_textarea {
    width: 100%;
    background: #ffffff;
    border: 0.01rem solid #f3cdc7;
    border-radius: 0.04rem;
    box-sizing: border-box;
    outline: none;
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 0.08rem;
    color: #334155;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  .feedback_input {
    height: 0.22rem;
    padding: 0 0.08rem;
  }

  .feedback_textarea {
    min-height: 0.64rem;
    padding: 0.08rem;
    resize: none;
  }

  .feedback_input:focus,
  .feedback_textarea:focus {
    border-color: #f39a89;
    box-shadow: 0 0 0 0.01rem rgba(255, 88, 54, 0.05);
  }

  .feedback_action {
    display: flex;
    justify-content: center;
  }

  .feedback_button {
    min-width: 1.14rem;
    height: 0.28rem;
    border: none;
    border-radius: 0.04rem;
    background: linear-gradient(180deg, #fb6137 0%, #f44a26 100%);
    color: #ffffff;
    font-family: Inter, Inter;
    font-weight: 700;
    font-size: 0.08rem;
    cursor: pointer;
    padding: 0 0.18rem;
  }

  @media screen and (max-width: 1200px) {
    .feedback_header {
      padding-left: 0.24rem;
      padding-right: 0.24rem;
    }

    .feedback_body {
      padding-left: 0.24rem;
      padding-right: 0.24rem;
    }

    .feedback_side {
      width: 2.8rem;
    }
  }

  @media screen and (max-width: 768px) {
    .feedback_top {
      min-height: auto;
      flex-direction: column;
    }

    .feedback_side {
      width: 100%;
      min-height: auto;
      padding: 0.34rem 0.2rem;
    }

    .feedback_side-content {
      margin-top: 0.34rem;
    }

    .feedback_side-title {
      font-size: 0.28rem;
      line-height: 0.34rem;
    }

    .feedback_side-text {
      width: 100%;
      font-size: 0.12rem;
      line-height: 0.2rem;
    }

    .feedback_header {
      height: auto;
      padding: 0.18rem 0.2rem;
    }

    .feedback_nav {
      gap: 0.16rem;
    }

    .feedback_nav-item {
      font-size: 0.1rem;
      line-height: 0.16rem;
    }

    .feedback_body {
      padding: 0.32rem 0.2rem 0.48rem;
    }

    .feedback_title {
      font-size: 0.24rem;
      line-height: 0.32rem;
    }

    .feedback_desc {
      font-size: 0.12rem;
      line-height: 0.2rem;
    }

    .feedback_form-card {
      width: 100%;
      padding: 0.18rem;
    }

    .feedback_row {
      flex-direction: column;
      gap: 0;
    }

    .feedback_label {
      font-size: 0.1rem;
      line-height: 0.16rem;
    }

    .feedback_input {
      height: 0.4rem;
      font-size: 0.12rem;
    }

    .feedback_textarea {
      min-height: 1.2rem;
      font-size: 0.12rem;
    }

    .feedback_button {
      min-width: 1.6rem;
      height: 0.42rem;
      font-size: 0.12rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/feedback.vue